"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.copyFailed = exports.copySuccess = exports.copyRequest = exports.removeFailed = exports.removeSuccess = exports.removeRequest = exports.toggleSelection = exports.setOrderBy = exports.setColumnFilter = exports.setPaginationOptions = exports.setSearchString = exports.setInitData = exports.bookmarkFailed = exports.bookmarkSuccess = exports.bookmarkRequest = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = void 0;
const ActionTypes = require("../../actionTypes/bid/list");
function fetchRequest(briefcase) {
    return {
        type: ActionTypes.FETCH_REQUEST,
        payload: briefcase
    };
}
exports.fetchRequest = fetchRequest;
function fetchSuccess(payload) {
    return {
        type: ActionTypes.FETCH_SUCCESS,
        payload
    };
}
exports.fetchSuccess = fetchSuccess;
function fetchFailed(payload) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload
    };
}
exports.fetchFailed = fetchFailed;
function bookmarkRequest(bid, briefcase, status, project) {
    return {
        type: ActionTypes.BOOKMARK_REQUEST,
        payload: {
            bid,
            briefcase,
            status
        }
    };
}
exports.bookmarkRequest = bookmarkRequest;
function bookmarkSuccess(payload) {
    return {
        type: ActionTypes.BOOKMARK_SUCCESS,
        payload
    };
}
exports.bookmarkSuccess = bookmarkSuccess;
function bookmarkFailed(payload, bid) {
    return {
        type: ActionTypes.BOOKMARK_FAILED,
        payload,
        bid
    };
}
exports.bookmarkFailed = bookmarkFailed;
function setInitData(data) {
    return {
        type: ActionTypes.SET_INIT_DATA,
        payload: data
    };
}
exports.setInitData = setInitData;
function setSearchString(data) {
    return {
        type: ActionTypes.SET_SEARCH_STRING,
        payload: data
    };
}
exports.setSearchString = setSearchString;
function setPaginationOptions(offset, limit) {
    return {
        type: ActionTypes.SET_PAGINATION_OPTIONS,
        payload: {
            offset,
            limit
        }
    };
}
exports.setPaginationOptions = setPaginationOptions;
function setColumnFilter(field, value) {
    return {
        type: ActionTypes.SET_COLUMN_FILTER,
        payload: {
            field,
            value
        }
    };
}
exports.setColumnFilter = setColumnFilter;
function setOrderBy(orderBy, order) {
    return {
        type: ActionTypes.SET_ORDER_BY,
        payload: {
            orderBy,
            order
        }
    };
}
exports.setOrderBy = setOrderBy;
function toggleSelection(id) {
    return {
        type: ActionTypes.TOGGLE_SELECTION,
        payload: {
            id
        }
    };
}
exports.toggleSelection = toggleSelection;
function removeRequest(bid) {
    return {
        type: ActionTypes.REMOVE_REQUEST,
        payload: {
            bid
        }
    };
}
exports.removeRequest = removeRequest;
function removeSuccess(id) {
    return {
        type: ActionTypes.REMOVE_SUCCESS,
        payload: {
            id
        }
    };
}
exports.removeSuccess = removeSuccess;
function removeFailed(payload) {
    return {
        type: ActionTypes.REMOVE_FAILED,
        payload
    };
}
exports.removeFailed = removeFailed;
function copyRequest(bid, briefcase) {
    return {
        type: ActionTypes.COPY_REQUEST,
        payload: {
            bid,
            briefcase
        }
    };
}
exports.copyRequest = copyRequest;
function copySuccess() {
    return {
        type: ActionTypes.COPY_SUCCESS
    };
}
exports.copySuccess = copySuccess;
function copyFailed(payload) {
    return {
        type: ActionTypes.COPY_FAILED,
        payload
    };
}
exports.copyFailed = copyFailed;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
//# sourceMappingURL=list.js.map